/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Withdraw_FirstInputs */

const en_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw from contract`)
};

const de_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertrag widerrufen`)
};

const fr_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se rétracter du contrat`)
};

const es_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desistir del contrato`)
};

const it_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recedi dal contratto`)
};

const nl_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract herroepen`)
};

const pl_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstąp od umowy`)
};

const fi_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta sopimus`)
};

const da_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortryd kontrakten`)
};

const sv_consumer_declaration_withdraw_first = /** @type {(inputs: Consumer_Declaration_Withdraw_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frånträd avtalet`)
};

/**
* | output |
* | --- |
* | "Withdraw from contract" |
*
* @param {Consumer_Declaration_Withdraw_FirstInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_withdraw_first = /** @type {((inputs?: Consumer_Declaration_Withdraw_FirstInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Withdraw_FirstInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_withdraw_first(inputs)
	if (locale === "fr") return fr_consumer_declaration_withdraw_first(inputs)
	if (locale === "es") return es_consumer_declaration_withdraw_first(inputs)
	if (locale === "it") return it_consumer_declaration_withdraw_first(inputs)
	if (locale === "nl") return nl_consumer_declaration_withdraw_first(inputs)
	if (locale === "pl") return pl_consumer_declaration_withdraw_first(inputs)
	if (locale === "fi") return fi_consumer_declaration_withdraw_first(inputs)
	if (locale === "da") return da_consumer_declaration_withdraw_first(inputs)
	if (locale === "sv") return sv_consumer_declaration_withdraw_first(inputs)
	return en_consumer_declaration_withdraw_first(inputs)
});